// Components
const ClientHeader = () => import(/* webpackPrefetch: true, webpackChunkName: "client-header" */ '@/app/views/client-view/_shared/client-header/client-header.vue');
const LandingPageHero = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-hero" */ '@/app/views/client-view/landing-page/components/landing-page-hero/landing-page-hero.vue');
const LandingPageCalculate = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-calculate" */ '@/app/views/client-view/landing-page/components/landing-page-calculate/landing-page-calculate.vue');
const LandingPageHowItWorks = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-how-it-works" */ '@/app/views/client-view/landing-page/components/landing-page-how-it-works/landing-page-how-it-works.vue');
const LandingPageGeneralInfo = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-general-info" */ '@/app/views/client-view/landing-page/components/landing-page-general-info/landing-page-general-info.vue');
const LandingPageTreatment = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-treatment" */ '@/app/views/client-view/landing-page/components/landing-page-treatment/landing-page-treatment.vue');
const LandingPageQuarterSection = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-quarter-section" */ '@/app/views/client-view/landing-page/components/landing-page-quarter-section/landing-page-quarter-section.vue');
const LandingPageFeatures = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-features" */ '@/app/views/client-view/landing-page/components/landing-page-features/landing-page-features.vue');
const LandingPagePlans = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-plans" */ '@/app/views/client-view/landing-page/components/landing-page-plans/landing-page-plans.vue');
const ClientFooter = () => import(/* webpackPrefetch: true, webpackChunkName: "client-footer" */ '@/app/views/client-view/_shared/client-footer/client-footer.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: 'the-footer' */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');
const LandingPagePawPrintTrail = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-paw-print-trail" */ '@/app/views/client-view/landing-page/components/landing-page-paw-print-trail/landing-page-paw-print-trail.vue');
const LandingPageHowToGet = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-how-to-get" */ '@/app/views/client-view/landing-page/components/landing-page-how-to-get/landing-page-how-to-get.vue');
const LandingPagePersonalised = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-personalised" */ '@/app/views/client-view/landing-page/components/landing-page-personalised/landing-page-personalised.vue');
const LandingPagePuppyPackSection = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-puppy-pack-section" */ '@/app/views/client-view/landing-page/components/landing-page-puppy-pack-section/landing-page-puppy-pack-section.vue')
const LandingPublicProductSearch = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-public-product-search" */ '@/app/views/client-view/landing-page/components/landing-public-product-search/landing-public-product-search.vue')
// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Services
import DefaultSettingsService from '@/app/services/main/default-settings/default-settings-service.js';

//Mixins
import { browserIdentifierMixins } from "@/app/mixins/utils/browser-identifier mixins.js";
import { googleTagManagerMixins } from '@/app/mixins/utils/google-tag-manager-mixins';

export default {
    name: 'LandPageContainer',
    mixins: [browserIdentifierMixins, googleTagManagerMixins],
    components: {
        ClientHeader,
        LandingPageHero,
        LandingPagePuppyPackSection,
        LandingPageCalculate,
        LandingPagePersonalised,
        LandingPageHowItWorks,
        LandingPageGeneralInfo,
        LandingPageFeatures,
        LandingPagePlans,
        LandingPageTreatment,
        LandingPagePawPrintTrail,
        LandingPageQuarterSection,
        LandingPageHowToGet,
        LandingPublicProductSearch,
        ClientFooter,
        TheFooter,
    },
    data() {
        return {
            totalPawPrintsHeight: 0,
            previousSection: '',
            landingPageSectionsIds: [
                'landing-page-section-1',
                'landing-page-section-2',
                'landing-page-section-3',
                'landing-page-section-4',
            ],
            landingPageViewedSections: [],
            appLinks : {
                appStoreLink: 'https://play.google.com/store/apps/details?id=com.lmdcmobile',
			    googlePlayLink: 'https://apps.apple.com/ph/app/love-my-dog-club/id1523977343'
            },
            quarterSectionTitlePlaceholder: '<b>Never forget to treat your dog</b> with automated flea, worm and tick alerts from over different <b>150 treatments</b> from <b>20 different companies</b> keeping a log of all treatments provided to your dog.',
            quarterSectionDescriptionPlaceholder: 'Set and monitor your dogs exercise both on and off leash. Report on amount and type of exercise your dog has received.',
            healthDataTitleHeader: 'Keep a log of all your daily activity with your Puppy, keep a history of exercise and reports.',
            healthDataDescriptions: [
                'Set and monitor your dogs exercise both on and off leash. Report on amount and type of exercise your dog has received.',
                'Be made aware of how your weekly exercise routine has been going, by our live interactive reports.'
            ],
            socialTitleHeader: 'Join the Love My Dog Club social club, or create your own club and share images or information to fellow Dog lovers.',
            socialDescriptions: ['Our social page allows you to connect with other people in Love My Dog Club, Share photos or experiences with other dog owners.', 'Create your own group, invite friends or others to join your own social group, have a walking group, a breed group or any type of dog related interaction.'],
            sittingTitleHeader: 'Find a walker/sitter to look after your bundle of joy!',
            sittingDescriptions: ['Use our search tool to find sitters or walkers close to you, connect with them to arrange a meet up.', 'Set yourself up as a sitter or walker within the app. Choose to charge clients or just do it for fun or exercise, connect with local dog owners.'],
            subscriptionTitleHeader: 'Find products that are specific for your Breed and Age of dog, no longer question is this the right product for my dog.',
            subscriptionDescriptions: ['Only see products that are specifically for the breed and age of your dog, no longer sift through hundred of items to see what is right for you and your dog.', 'Use your store credit to purchase through the app, or just buy direct via credit card, see monthly specials and bonus buys, for your breed of dog.']
        }
    },
	created() {
		this.getStoreLink();
	},
    beforeDestroy() {
        if (!this.isMobile()) {
            $(window).off('scroll')
        }
    },
    mounted() {
        if (!this.isMobile()) {
            $(window).on('scroll', e =>{
                this.animatePawPrints()
            })
        }

        this.scrollIntoSection();
    },
    methods: {
        isMobile() {
            return window.innerWidth < 1024
        },
        animatePawPrints() {
            for (const index in this.landingPageSectionsIds) {
                const elementId = this.landingPageSectionsIds[index]
                if (!this.landingPageViewedSections.includes(elementId)) {
                    this.isElementInViewport(elementId, this.landingPageSectionsIds.length - 1 === index)
                }
            }
        },

        scrollIntoSection() {
            if (this.$route.hash) {
                if (this.checkBrowser() === "safari") {
                    setTimeout(() => {
                        const element = document.querySelector(`${this.$route.hash}`);
                        this.scrollElementIntoView(element);
                    }, 500);
                } else {
                    setTimeout(() => {
                        const element = document.querySelector(`${this.$route.hash}`);
                        element.scrollIntoView({ behavior: "smooth" });
                    }, 500);
                }
            } else {
                window.scrollTo(0, 0)
            }
        },

        scrollElementIntoView(element) {
            const finalOffset = element.getBoundingClientRect().top;

            window.parent.scrollTo({
                top: finalOffset,
            });
        },

        isElementInViewport(id, lastSection) {
            var element = this.$refs[id];
            const elementPosition = element.getBoundingClientRect().y
            const elementHeight = element.clientHeight
            const sectionIds = this.landingPageSectionsIds
            if (lastSection || sectionIds[sectionIds.length - 1] === id ? elementPosition < 575 : false) {
                this.landingPageViewedSections.push(id)
                this.totalPawPrintsHeight += elementHeight
            } else {
                if (elementPosition < elementHeight - (elementHeight / 1.5)) {
                    this.landingPageViewedSections.push(id)
                    this.totalPawPrintsHeight += elementHeight
                }
            }
        },
        getStoreLink() {
			const queryParams = {
				f_code: 'LINK',
				f_environment: 'MOB'
			}

			DefaultSettingsService.getDefaultSettings(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.appLinks.googlePlayLink = res.data.find(data => data.id === 1).value;
						this.appLinks.appStoreLink = res.data.find(data => data.id === 2).value;
					}
				})
		},
        gotoPuppyList() {
			this.$router.push(`/puppy-for-sale`)
		},
    }
}